// Tracciati 24x24 a tratto per <Icona> (Marchio.tsx): menu, barra e spie del cruscotto.
export const ICONE = {
  cruscotto: 'M12 14l4-4M3.5 16a8.5 8.5 0 1 1 17 0',
  impianti: 'M13 2 4 14h7l-1 8 9-12h-7z',
  calendario: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  documento: 'M7 3h7l5 5v13H7zM14 3v5h5',
  registro: 'M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3zM9 9h6M9 13h6',
  grafico: 'M4 19h16M7 16V10M12 16V6M17 16v-4',
  avviso: 'M12 3 2 20h20zM12 10v4M12 17v.5',
  regolazioni: 'M4 7h10M18 7h2M4 17h4M12 17h8M14 4v6M8 14v6',
  clienti: 'M16 19v-1a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v1M10 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M20 19v-1a3 3 0 0 0-2-2.8',
  impostazioni: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6M4 12h2M18 12h2M12 4v2M12 18v2M6.3 6.3l1.4 1.4M16.3 16.3l1.4 1.4M6.3 17.7l1.4-1.4M16.3 7.7l1.4-1.4',
  orologio: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 7v5l3 2',
  chiave: 'M14 10a4 4 0 1 0-4-4M10 8 3 15v3h3l7-7',
  aiuto: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M9.5 9a2.5 2.5 0 1 1 3 2.4c-.6.2-1 .7-1 1.3V14M12 17v.5',
} as const

export type NomeIcona = keyof typeof ICONE
